module.exports = __webpack_public_path__ + "img/box.fb932f3c.svg";